<template>
<div class="h-screen flex w-full bg-img">
    <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
        <img src="@/assets/images/HoltEstateLogowhite.png" class="mx-auto mb-2 max-w-full custom-logo-size">
        <h3 class="sm:mx-0 mx-4 mb-2 text-2xl text-white">Please Wait</h3>
        <vs-terms></vs-terms>
        <h6 class="sm:mx-0 m-base mb-6 text-lg text-white">Version: {{ currentVersion }}</h6>
    </div>
</div>
</template>

<script>
import {
    version
} from '../../../package.json';

export default {
    data() {
        return {
            currentVersion: version,
        }
    },
    created() {
        console.log("completing sign up");
        this.$router.push("/relogin");
    },
    methods: {}
}
</script>

<style scoped>
.custom-logo-size {
    width: 40rem;
}
</style>
